import { OnboardingStatusType } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { useNotify } from 'libs/notify';

export const useNotifySuccessSave = () => {
  const notify = useNotify();
  const { t } = useTranslation();

  return (
    status?: OnboardingStatusType,
    brightType: 'update' | 'create' = 'update',
    isBrightSyncEnabled = false
  ) => {
    notify.info(t('common.successSave'));

    if (status === OnboardingStatusType.AccountOpened && isBrightSyncEnabled) {
      notify.info(
        t(
          brightType === 'update'
            ? 'client.client.statuses.updateBrightText'
            : 'client.client.statuses.createBrightText'
        )
      );
    }
  };
};
